import React from 'react';
import { Switch } from 'react-router-dom';
import { AnalyticsEventSource, ApprovalDeskPageType, ScreenEventAnalytics, PAGETITLE } from '@atlassian/temp-analytics';
import { ProxyGraphClients } from '@atlassian/temp-client-utils';
import {
  getAdminTaskManagerPath,
  getAdminTaskRoutePath,
  getProcessManagerPath,
  getProcessManagerReportPath,
  withConfirmationDialog,
} from '@css-xp/apd-common';
import { SIDEBAR_TASK_DETAIL, TaskDetailPage } from '@css-xp/apd-task-manager';
import { AppContent, AppPage, RouteWithAnalytics } from '@css-xp/base';
import AdminTaskManager from './admin-task-manager/admin-task-manager';
import './process-manager.scss';
import Report from './report/report';
import RuleManager from './rule-manager/rule-manager';

const allowedSidebars = {
  [SIDEBAR_TASK_DETAIL]: TaskDetailPage,
};

const ProcessManager = () => {
  return (
    <AppPage className="apd-app-page" allowedSidebars={allowedSidebars}>
      <ScreenEventAnalytics
        event={{
          name: AnalyticsEventSource.APPROVAL_DESK_SCREEN,
          attributes: {
            pageType: ApprovalDeskPageType.PROCESS_MANAGER,
          },
        }}
      />
      <AppContent className="app-content">
        <div className="process-manager">
          <Switch>
            <RouteWithAnalytics
              source={AnalyticsEventSource.APPROVAL_DESK_SCREEN}
              path={getAdminTaskRoutePath()}
              render={() => <AdminTaskManager title={PAGETITLE.APPROVAL_DESK} />}
              srcProxy={ProxyGraphClients.APD}
            />
            <RouteWithAnalytics
              source={AnalyticsEventSource.APPROVAL_DESK_SCREEN}
              path={getAdminTaskManagerPath()}
              render={() => <AdminTaskManager title={PAGETITLE.APPROVAL_DESK} />}
              srcProxy={ProxyGraphClients.APD}
            />
            <RouteWithAnalytics
              source={AnalyticsEventSource.APPROVAL_DESK_SCREEN}
              path={getProcessManagerReportPath()}
              component={Report}
              srcProxy={ProxyGraphClients.APD}
            />
            <RouteWithAnalytics
              source={AnalyticsEventSource.APPROVAL_DESK_SCREEN}
              path={getProcessManagerPath()}
              component={RuleManager}
              srcProxy={ProxyGraphClients.APD}
            />
          </Switch>
        </div>
      </AppContent>
    </AppPage>
  );
};

export default withConfirmationDialog(ProcessManager);
